import { useGetFacilitiesV2Query } from "@/features/api/apiSlice";
import { useDisplayOptionContext } from "@/hooks/useDisplayOptionContext";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Skeleton } from "@/components/ui/skeleton";
import ErrorBoundary from "@/components/ErrorBoundary";
import { sanitizePhoneNumber, formatPhoneNumber } from "@/utils/phone/phoneUtils";

export const UnitError = () => {
    const options = useDisplayOptionContext();

    const { data, error, isLoading } = useGetFacilitiesV2Query({
        ids: String(options.facilityIds[0]),
    });
    return (
        <Card>
            <CardHeader>
                <CardTitle>
                    <h2>
                        We're sorry, we are having trouble retrieving units at
                        this time.
                    </h2>
                </CardTitle>
            </CardHeader>
            <CardContent>
                {error ? (
                    "Oh no, there was an error! {error.status}"
                ) : isLoading ? (
                    <Skeleton className="tw:w-[200px] tw:h-[20px] tw:rounded-full" />
                ) : data && data.data && data.data.length > 0 ? (
                    <ErrorBoundary>
                        <p>
                            For more information on unit availability, please
                            call{" "}
                            <a
                                href={`tel:${sanitizePhoneNumber(data.data[0].phone)}`}
                            >
                                {formatPhoneNumber(data.data[0].phone)}
                            </a>
                        </p>
                    </ErrorBoundary>
                ) : null}
            </CardContent>
        </Card>
    );
};
